import { createClient } from 'contentful';

const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'hhtw5wxm9bq2';
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || '70cfa26876118c936e0c5b1bd4f28bf8247d91dcac79f338717f0ddab39451d6';
const HOST = process.env.REACT_APP_CONTENTFUL_HOST || 'cdn.contentful.com';

const client = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  host: HOST,
});

// get navigation
export const getNavi = (locale) => client.getEntries({
  content_type: 'navigation',
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.entries',
  ],
})
.then(response => response.items[0].fields.entries)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

export const getPage = (slug, locale) => client.getEntries({
  content_type: 'page',
  'fields.slug': slug,
  include: 2,
  locale,
  select: [
    'fields.slug',
    'fields.title',
    'fields.elements',
  ],
})
.then(response => {
  if (response.items.length === 0) {
    // Page not found!?!?
    return null;
  }
  return response.items[0].fields
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});


export const getReservationTexts = (locale) => client.getEntries({
  content_type: 'reservationTexts',
  limit: 1,
  locale,
  select: [
    'fields.backgroundImage',
    'fields.onlineBookingInfo',
    'fields.groupReservationInfo'
  ]
})
.then(response => ({
  ...response.items[0].fields
}))
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getHours = (locale) => client.getEntries({
  content_type: 'contactUs',
  limit: 1,
  locale,
  select: [
    'fields.openingHours'
  ]
})
.then(response => response.items[0].fields.openingHours)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get front page
export const getFront = (locale) => client.getEntries({
  content_type: 'frontPage',
  limit: 1,
  locale,
  include: 10,
  select: [
    'fields.header',
    'fields.containers'
  ]
})
.then(response => {
  return {
    "header":response.items[0].fields.header.fields,
    "containers":response.items[0].fields.containers
  }
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Menus
export const getMenus = (locale) => client.getEntries({
  content_type: 'menu',
  order: 'fields.order',
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getContact = (locale) => client.getEntries({
  content_type: 'contactUs',
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.header',
    'fields.leftColumn',
    'fields.rightColumn'
  ]
})
.then(response => {
  return {
  "header":response.items[0].fields.header.fields,
  "leftColumn":response.items[0].fields.leftColumn,
  "rightColumn":response.items[0].fields.rightColumn
}})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get blog page
export const getBlog = (locale) => client.getEntries({
  content_type: 'blogPage',
  limit: 1,
  locale,
  include: 10,
  select: [
    'fields.header',
  ]
})
.then(response => {
  return {
    "header":response.items[0].fields.header.fields,
  }
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get list of blog posts
export const getBlogs = (locale, limit = 1, offset = 0) => client.getEntries({
  content_type: 'blogPost',
  order: '-fields.published',
  limit: limit,
  skip: offset,
  include: 10
})
.then(response => {
  return response.items;
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get individual blog post by slug
export const getPost = (slug) => client.getEntries({
  'fields.slug': slug,
  content_type: 'blogPost',
  limit: 1,
  skip: 0,
  include: 10,
})
.then(response => {
  if (response.items.length > 0) {
    return response.items[0].fields;
  } else {
    // Invalid slug
    return null;
  }
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});



// WEBPACK FOOTER //
// ./src/api/contentfulAPI.js